var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6164,
    cy: 28.6164,
    r: 21.6164,
    fill: "#FBD904",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8774 9.94572C45.3416 9.40991 44.6149 9.10889 43.8571 9.10889H23.8571C23.0994 9.10889 22.3727 9.40991 21.8368 9.94572M21 18.6089V26.2517C21 27.0095 21.301 27.7362 21.8368 28.272C22.3727 28.8079 23.0994 29.1089 23.8571 29.1089H43.8571C44.6149 29.1089 45.3416 28.8079 45.8774 28.272C46.4133 27.7362 46.7143 27.0095 46.7143 26.2517V18.6089",
    stroke: "#434343",
    strokeWidth: 2.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.1089L32.2714 21.6232C32.7409 21.9364 33.2927 22.1036 33.8571 22.1036C34.4216 22.1036 34.9733 21.9364 35.4429 21.6232L46.7143 14.1089",
    stroke: "#FBD904",
    strokeWidth: 2.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2d14ffc3fa02c9efb42f6f957e45d259.svg";
export { ForwardRef as ReactComponent };